import { PUBLIC_DEFAULT_LANGUAGE } from '$env/static/public'
import { page } from '$app/state'

/**
 * @param {string} name
 * @param {{ domain?: string, url?: string|URL, referrer?: string, props?: Object<string, any>, revenue?: Schema.Money }} [params]
 */
export function track(name, params) {
  let url = new URL(page.url)
  if (!params?.url && page.route?.id) {
    const route = page.route.id
      // Remove language slug
      .replace(/^\/\[\[lang=language\]\]/, '')
      // Replace slug placeholder with actual value
      .replace('[slug]', page.params?.slug || '[slug]')

    const { search } = url
    url = new URL(route || '/', url)
    url.search = search
  }

  const { agent } = page.data
  const body = {
    name,
    domain: `allaboard.eu,${agent.uid}.allaboard.eu`,
    ...params,
    // Remove trailing slashes
    url: String(params?.url || url).replace(/\/$/, ''),
    props: {
      // Always include language
      lang: page.data?.language || PUBLIC_DEFAULT_LANGUAGE,
      // Allways include page title
      title: document.title,
      // Include route params for good measure
      ...page.params,
      ...params?.props
    }
  }

  return fetch(new URL('/stats/event', url), {
    method: 'POST',
    keepalive: true,
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body)
  })
}
